const parsingData = {
    consumptions: 'Consommation',
    representatives: 'Représentant légal',
    adresses: 'Addresse',
    update_instructions: 'Consigne du contrat',
    mail_withdrawal_proxies: 'Pouvoir Courrier',
    contracts: 'Contrat',
    brands: 'Marque',
    validation_requests: 'Demande de validation',
    customers: 'Client',
    carts: 'Panier',
}

const parse = (config) => {
    const baseURL = config.baseURL,
        fullURL = config.url,
        url = fullURL.replace(baseURL, "")

    let ret = _.reduce(
        parsingData,
        (res, val, key) => {
            const resource = url.lastIndexOf(key)
            if (!_.isEmpty(res))
                return res
            if (resource !== -1)
                res += val
            return res
        },
        ""
    )
    // debugger
    return ret
}

const success = (response, store, uid) => {
    const state = store.state,
        config = response.config,
        method = config.method,
        isFormReturn = config.url.indexOf('search') === -1 && (method === "put" || method === "post" || method === "delete"),
        isAnSAPExport = response.data.hasOwnProperty("result") && response.data.result.hasOwnProperty('customer'),
        data = {}

    let mutation = 'FORM_SUCCESS'

    if (!isFormReturn || isAnSAPExport)
        return;
    // debugger
    data.resource = parse(config)
    data.method = method
    /*    if (!_.isNull(uid))
            mutation = `${uid}/${mutation}`*/
    store.commit(mutation, data)
}

const error = (response, store, uid) => {
    const state = store.state,
        config = response.config,
        method = config.method,
        isFormReturn = method === "put" || method === "post" || method === "delete",
        isAnSAPExport = response.data.hasOwnProperty("result") && response.data.result.hasOwnProperty('customer'),
        data = _.assign({}, response.data)

    let mutation = 'FORM_ERROR'

    if (!isFormReturn || isAnSAPExport)
        return;

    data.resource = parse(config)
    data.method = method
    if (!_.isEmpty(uid))
        mutation = `${uid}/${mutation}`
    store.commit(mutation, data)
}

export default {
    success,
    error
}



// WEBPACK FOOTER //
// ./client/utils/formAxiosInterceptors.js